<!--
// app/components/pages/mercato/MercatoFaqs.vue
-->
<script setup lang="ts">
import FaqItem from "~/components/pages/region-faqs/FaqItem.vue";

const { $t } = useI18n();

// Number of FAQs to display
const FAQ_COUNT = 12;

const faqs = computed(() => {
  const faqsList = [];
  for (let i = 1; i <= FAQ_COUNT; i++) {
    const question = $t(`mercato.faqs.question${i}`);
    const answer = $t(`mercato.faqs.answer${i}`);

    // Only add FAQ if translation exists

    if (question !== `mercato.faqs.question${i}`) {
      faqsList.push({
        question,
        answer,
      });
    }
  }
  return faqsList;
});

const createFaqSchema = (): string[] => {
  const allQuestions = [];
  if (faqs.value) {
    for (const faq of faqs.value) {
      allQuestions.push(
        `{"@type": "Question", "name": "${faq.question}", "acceptedAnswer": {"@type": "Answer","text": "${faq.answer}"}}`
      );
    }
  }

  return allQuestions;
};

const faqSchema = createFaqSchema();

if (!!faqSchema) {
  useHead({
    script: [
      {
        type: "application/ld+json",
        innerHTML: `{"@context": "https://schema.org","@type": "FAQPage","mainEntity": [${faqSchema}]}`,
        tagPosition: "head",
        tagPriority: "low",
        key: "schemaQuestions",
      },
    ],
  });
}
</script>

<template>
  <section class="mercato-faqs bg-gray-900 py-10 !mb-0">
    <div>
      <h2 class="text-center pb-12">{{ $t("mercato.faqs.title") }}</h2>

      <div id="faqs-accordion" class="max-w-2xl mx-auto px-4 sm:px-2 bigsm:px-0">
        <faq-item
          v-for="(faq, index) in faqs"
          :key="index"
          :title="faq.question"
          :content="faq.answer"
          class="mercato-faq-item"
        />
      </div>
    </div>
  </section>
</template>

<style scoped>
.mercato-faqs :deep(.mercato-faq-item h3) {
  @apply transition-colors duration-200;
}

.mercato-faqs :deep(.mercato-faq-item button) {
  @apply transition-all duration-200;
}

.mercato-faqs :deep(.mercato-faq-item button[aria-expanded="true"]) {
  @apply border-b-mercato;
}

.mercato-faqs :deep(.mercato-faq-item button[aria-expanded="true"] h3) {
  @apply !text-mercato !font-bold;
}

.mercato-faqs :deep(.mercato-faq-item button[aria-expanded="true"] svg) {
  @apply text-mercato;
}

/* Style for lists in FAQ content */
.mercato-faqs :deep(.mercato-faq-item ul) {
  @apply list-disc pl-6 mt-2 mb-2;
}

.mercato-faqs :deep(.mercato-faq-item ol) {
  @apply list-decimal pl-6 mt-2 mb-2;
}

.mercato-faqs :deep(.mercato-faq-item li) {
  @apply mb-1;
}

.mercato-faqs :deep(.mercato-faq-item p) {
  @apply mb-3;
}

.mercato-faqs :deep(.mercato-faq-item strong) {
  @apply font-semibold text-white;
}
</style>
